
const   navTabElements=document.querySelectorAll('.menu-drawer__navigation details');


if(navTabElements){
    Object.entries(navTabElements).forEach(entry => {
        const [key, el] = entry;
        el.addEventListener('click',function (event){
            // event.preventDefault();
            const sab_menu =  el.querySelector('.icon-caret');
            console.log(sab_menu);
            if(sab_menu.classList.contains('svg_flip')){
                sab_menu.classList.remove('svg_flip');
            }else{
                sab_menu.classList.add('svg_flip');
            }


        })
        // console.log(key, value);
    })
}



const   filterButton  = document.querySelector('.refine_sort');

if(filterButton){
    filterButton.addEventListener('click',function (){
        event.preventDefault();
        const facets =  document.querySelector('.facets');
        if(facets.classList.contains('small-hide')){
            facets.classList.remove('small-hide');
        }else{
            facets.classList.add('small-hide');
        }

    });
}

const   closeButton  = document.querySelector('.close_icon span');
if(closeButton){

    closeButton.addEventListener('click',function (){

        const   closeIcon  = document.querySelector('.header__icon--menu');


        console.log(closeIcon);
        closeIcon.dispatchEvent(new Event('click'));
      


    });

}
